import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useParams, Link } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';
import { useViewport } from '../../context/ViewportContext';
import {useModelData} from '../../hooks/useModelData';
import A1LayoutOcxoParams from "../OcxoParams/A1LayoutOcxoParams"
import A2LayoutOcxoParams from "../OcxoParams/A2LayoutOcxoParams"

import DisplayStore2 from "../Helper/DisplayStore2"
//axl2/ContactForms/ContactForm.jsx
//src/axl2/Helper/DisplayStore2.jsx

// Import from products slice
import { 
  fetchProductById, 
  clearCurrentProduct,
  selectCurrentProduct,
  selectParentGroup,
  selectLoadingProduct,
  selectErrorProduct,
  //selectImagePath,
} from '../../store/productsSlice';

//import {iconMap} from "../Service/srv_iconMap"
import { getIcon } from "../Service/srv_iconMap";


import ProductImageViewer from "./ProductImageViewer"
import ContactForm from "../ContactForms/ContactFormShort"
//import ContactFormL from "../ContactForms/ContactForm"
//import ContactForm from "./ContactForm"
//import ProductTabs from "./ProductTabs"
import "../../assets/css_axl/style3.css";

//import Header from "../Header/Header";

// Hooks
//import { useMenu } from "../../hooks/useMenu";



const PageModel = () => {
  const { isMobile } = useViewport();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get productId from URL params
  const { productId } = useParams();
    const {
      currentProduct, 
      relativeProducts,
      currentProductViewerData,
      currentProductToDo,
      partNumber,

    } = useModelData(); // Use the correct hook name
  

      // Add this effect to scroll to top when page loads
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Also handle browser back/forward navigation
    const handlePopState = () => {
      window.scrollTo(0, 0);
    };
    
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [productId]); // Run when productId changes

  //  console.log(partNumber)
  
  // Use custom menu hook
  //const { isMenuOpen, toggleMenu: handleToggleMenu, closeMenu: handleCloseMenu } = useMenu();
  
  // Select data from Redux
  const product = useSelector(selectCurrentProduct);
  const selectedGroupData = useSelector(selectParentGroup);
  const loading = useSelector(selectLoadingProduct);
  const error = useSelector(selectErrorProduct);
  //const imagePath = useSelector(selectImagePath);

  //console.log(product)
  //const eee =  useSelector((state) => state.products)
  //console.log(eee)

  // Fetch product when component mounts or productId changes
  useEffect(() => {
    if (productId) {
      dispatch(fetchProductById(productId));
    }
    
    // Clean up when component unmounts
    return () => {
      dispatch(clearCurrentProduct());
    };
  }, [productId, dispatch]);

  
  // -- SCROLL TO FORM ----
  const formRef = useRef(null);
  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  // -- SCROLL TOP ----
  const [showScrollTop, setShowScrollTop] = useState(false);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Show/hide scroll-to-top button based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  

/* **** BEGIN ALTERNATIVES LOOK ************** */
  // Show loading state
  if (loading) {
    return (
      <div>
{/*         <Header
          isMenuOpen={isMenuOpen}
          toggleMenu={handleToggleMenu}
          closeMenu={handleCloseMenu}
        /> */}
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center pt-20">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#5c67aa] mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading product details...</p>
          </div>
        </div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div>
{/*         <Header
          isMenuOpen={isMenuOpen}
          toggleMenu={handleToggleMenu}
          closeMenu={handleCloseMenu}
        /> */}
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center pt-20">
          <div className="text-center max-w-md">
            <div className="w-12 h-12 text-red-500 mx-auto mb-4">⚠️</div>
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Product Not Found</h3>
            <p className="text-gray-600 mb-4">Product {productId} could not be found.</p>
            <button 
              onClick={() => navigate('/')}
              className="px-4 py-2 bg-[#5c67aa] text-white rounded-lg hover:bg-[#4f5aa3] transition-colors"
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Show product not found state
  if (!product) {
    return (
      <div>
{/*         <Header
          isMenuOpen={isMenuOpen}
          toggleMenu={handleToggleMenu}
          closeMenu={handleCloseMenu}
        /> */}
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center pt-20">
          <div className="text-center">
            <div className="w-16 h-16 text-gray-400 mx-auto mb-4">📦</div>
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Product Not Found</h3>
            <button 
              onClick={() => navigate('/')}
              className="px-4 py-2 bg-[#5c67aa] text-white rounded-lg hover:bg-[#4f5aa3] transition-colors"
            >
              View All Products
            </button>
          </div>
        </div>
      </div>
    );
  }

/* **** END ALTERNATIVES LOOK ************** */

// Helper to get icon component
/* const getIconComponent = (iconName) => {
  return iconMap[iconName] || Clock;
};
 */

/* **** BEGIN ITEM BLOCKS FOR MAIN CODE ************** */

const desktopBgBage = [
  "bg-green-100 text-green-800 border-green-200",    // 0 - Fresh/Performance
  "bg-orange-100 text-orange-800 border-orange-200", // 1 - Warning/Power
  "bg-purple-100 text-purple-800 border-purple-200", // 2 - Precision/Tech
  "bg-amber-100 text-amber-800 border-amber-200",    // 3 - Energy/Heat
  "bg-indigo-100 text-indigo-800 border-indigo-200", // 4 - Stability/Trust
  "bg-red-100 text-red-800 border-red-200",          // 5 - Critical/Shock
  "bg-blue-100 text-blue-800 border-blue-200",       // 6 - Reliability
  "bg-pink-100 text-pink-800 border-pink-200",       // 7 - Sensitivity
  "bg-teal-100 text-teal-800 border-teal-200",       // 8 - Efficiency
  "bg-cyan-100 text-cyan-800 border-cyan-200",       // 9 - Innovation
  "bg-lime-100 text-lime-800 border-lime-200",       // 10 - Growth
  "bg-rose-100 text-rose-800 border-rose-200",       // 11 - Excellence
];

const desktopGrayFallback = "bg-gray-100 text-gray-700 border-gray-200";

const Badges = () => {
  // Use the same data source for both
  const badgesData = selectedGroupData.specifications || [];
  
  // If no data, return null
  if (badgesData.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 justify-center lg:justify-start">
      {badgesData.map((spec, index) => {
        const IconComponent = getIcon(spec.icon);//getIconComponent(spec.icon);
        const colorClasses = !isMobile 
        ? (index < desktopBgBage.length ? desktopBgBage[index] : desktopGrayFallback)
        : "bg-white/80 backdrop-blur-sm text-gray-700 border-gray-200";
        if (isMobile && !spec.mobileDisplay) return null;
        return (
          <div
            key={index}
            className={`
              inline-flex
              items-center
              gap-1.5
              px-3
              py-1.5
              rounded-full
              text-xs
              font-semibold
              ${colorClasses}
              backdrop-blur-sm
              border
              border-gray-200
              text-gray-700
              hover:border-gray-300
              ${!isMobile ? 'hover:brightness-95' : 'hover:bg-white'}
              transition-all
              duration-200
              shadow-sm
            `}
          >
            <IconComponent className="w-3.5 h-3.5 text-gray-600" />
            <span>{spec.value}</span>
          </div>
        );
      })}
    </div>
  );
};


  const ToDo = () => {
    if (!currentProductToDo?.length) return null;
    return (
      <div className="space-y-3 m-5">
          {/* Subtle Caption */}
          <div className="pb-2 border-b border-gray-200">
            <h4 className="text-sm font-medium text-gray-500 uppercase tracking-wider">To Do</h4>
          </div>
          
          {/* List */}
          <div className="space-y-2">
            {currentProductToDo.map((item, index) => {
              const content = item.replace(/<\/?p>/g, '');
              
              return (
                <div key={index} className="p-3 bg-gradient-to-r from-gray-50 to-white rounded-lg border border-gray-100">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-2 h-2 mt-2 rounded-full bg-blue-500 mr-3"></div>
                    <div className="text-gray-700">{content}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
    )
  }
  
  const RelativeProducts = () => {
    return (
      /* BUTTONS - Golden ratio width: 400/1.618 ≈ 247px */
      <div className="
        flex flex-col 
        gap-3 
        w-full 
        p-8
    
      ">
      {/* {["XBO20S 20x20x15 mm", "XBO20 20x20x15 mm"].map((pack, index) => { */}
      {relativeProducts?.descrArray.map((pack, index) => {
          //const isSelected = 1;
          const isSelected = (index === relativeProducts?.activeIndex)? 1 : "";
          
          const to = `/product/model/${relativeProducts?.idArray[index]}`;

          return (
            <Link
              key={`${pack}-${index}`}
              to={to}
              className={`      
                inline-flex
                items-center
                justify-center
                h-12
                px-6
                border-2
                rounded-lg
                font-medium
                transition-all
                duration-300
                hover:scale-[1.02]
                hover:shadow-lg
                active:scale-[0.98]
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-blue-500
                no-underline
                ${isSelected 
                  ? 'border-blue-500 bg-blue-50 text-blue-700 font-bold shadow-md ring-2 ring-blue-200 cursor-default' 
                  : 'border-gray-300 bg-white text-gray-700 hover:border-blue-300 hover:bg-blue-50'
                }`}
              aria-current={isSelected ? "page" : undefined}
              title={`Select ${pack} package`}
              onClick={isSelected ? (e) => e.preventDefault() : undefined}
            >
              <span className="flex items-center justify-center gap-2">
                {pack}
                {isSelected && (
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                )}
              </span>
            </Link>
          );
        })
        }
      </div>  
    )
  }
  /* **** END ITEM BLOCKS FOR MAIN CODE ************** */


  /* ***** MAIN CODE *********************** */
return (
  <>
    <div className="max-w-screen-2xl mx-auto text-gray-800 px-4 sm:px-6 lg:px-8 pt-20 pb-8">
      {/* If Exist */}
      <ToDo />

      {/* Main Content Container */}
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left Column - Product Info (40% on desktop) */}
        <div className="lg:w-1/2">
          <div className="mb-8">
            {/* Main Title Row */}
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-4">
              <div>
                <h3 className="text-3xl font-bold border-b-4 border-blue-500 inline-block pb-1">
                  {product.name}
                </h3>
                {product.description && (
                  <p className="text-gray-600 mt-2 text-sm">
                    {product.description}
                  </p>
                )}
              </div>
              
              {/* Action Buttons */}
              <div className="flex items-center justify-center">
  <div className="flex gap-2 flex-wrap w-full sm:w-auto justify-center">
    <button 
      className="flex-1 sm:flex-none min-w-[140px] bg-white text-blue-700 border-2 border-blue-700 hover:bg-blue-700 hover:text-white transition-all duration-200 py-2 px-2 rounded-lg font-semibold flex items-center justify-center text-sm"
      onClick={() => { 
        if (currentProduct?.pdfUrl) {
          window.open(currentProduct.pdfUrl, '_blank');
        }
      }}>
      <span className="mr-2">📄</span>
      Full Spec PDF
    </button>
    
    <button 
      onClick={scrollToForm}
      className="flex-1 sm:flex-none min-w-[140px] bg-blue-600 text-white hover:bg-blue-700 transition-all duration-200 py-2 px-2 rounded-lg font-semibold flex items-center justify-center text-sm shadow-sm">
      <span className="mr-2">📋</span>
      Product Inquiry
    </button>
  </div>
</div>

            </div>

            {/* Quick Specs Badges */}
            <Badges />
          </div>

          {/* Relative Products & VIEWER */}
          <div className="flex flex-col gap-4">
            {/* Relative Products Navigation */}
            <RelativeProducts />
            
            {/* Product Image Viewer */}
            <div className="w-full">
              <ProductImageViewer images={currentProductViewerData} />
            </div>
          </div>
        </div>

        {/* Right Column - Configuration Form (60% on desktop) */}
        <div className="lg:w-1/2">
          <div className="text-gray-800 pt-0 pb-8">
            {selectedGroupData?.layoutOcxoParams=="A1LayoutOcxoParams"
              &&
              <A1LayoutOcxoParams />
            }
            {selectedGroupData?.layoutOcxoParams=="A2LayoutOcxoParams"
              &&
              <A2LayoutOcxoParams />
            }            
          </div>
        </div>
      </div>

      {/* Blue Horizontal Line */}
      <div className="w-full pt-8">
        <div className="border-b-4 border-blue-500"></div>
      </div>

      {/* Contact Form Section */}
      <div ref={formRef} className="pt-8">
        <ContactForm />
      </div>
    </div>

    {/* Scroll-to-Top Button */}
    {showScrollTop && (
      <button
        onClick={scrollToTop}
        className="
          fixed 
          md:bottom-4 md:right-4 
          bottom-1/2 right-4 
          transform 
          md:translate-y-0 -translate-y-1/2 
          bg-white 
          hover:bg-blue-50 
          text-blue-500 
          p-2 
          rounded-full 
          shadow-lg 
          border 
          border-blue-200 
          transition 
          duration-300 
          z-50
          flex items-center justify-center
          w-10 h-10
        "
        aria-label="Scroll to top"
      >
        <ArrowUp size={20} />
      </button>
    )}

    {/* process.env.NODE_ENV === 'development' && <DisplayStore2 /> */}
  </>
);
};

export default PageModel;